import { render } from "./SellsyAIMenu.vue?vue&type=template&id=5018908a"
import script from "./SellsyAIMenu.vue?vue&type=script&lang=js"
export * from "./SellsyAIMenu.vue?vue&type=script&lang=js"

import "./SellsyAIMenu.vue?vue&type=style&index=0&id=5018908a&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__